/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import CreditCardIcon from '@mui/icons-material/CreditCardOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { useEditUserMutation, useGetMemberSignUpFormQuery } from 'store/api/version-api.slice';

import { styles } from './styles';

const MemberSignUps = () => {
	const navigate = useNavigate();

	const { data: memberSignUpFormResponse = {} } = useGetMemberSignUpFormQuery();
	const memberSignUpForms = useMemo(() => memberSignUpFormResponse.results || [], [memberSignUpFormResponse.results]);

	const [editUser] = useEditUserMutation();

	const finish = async () => {
		await editUser({ next_url: 0 });

		navigate('dashboard');
	};

	return (
		<Grid container spacing={2} sx={{ display: 'flex' }}>
			<Grid item xs={12}>
				<List sx={styles.root}>
					<ListItem alignItems="flex-start">
						<ListItemAvatar>
							<Avatar sx={styles.avatar}>
								<CreditCardIcon />
							</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={
								<>
									<Typography component={'span'} variant="h4" color="primary">
										BEGIN SIGNING UP NEW MEMBERS
									</Typography>
								</>
							}
							secondary={
								<>
									<Typography component={'span'} variant="h5" color="secondary">
										EMBED YOUR NEWLY CREATED FORM ON YOUR WEBSITE
									</Typography>
								</>
							}
						/>
					</ListItem>
				</List>
				{memberSignUpForms.map((form, index) => (
					<Box key={`member-form-${index}`} sx={{ display: 'flex', flexDirection: 'column' }}>
						<Typography component={'span'} variant={'h6'}>
							Embeddable Code:
						</Typography>
						<Typography component={'span'} sx={styles.code_block}>
							{form.last_form_code}
						</Typography>
					</Box>
				))}
				<Button variant="contained" color="primary" fullWidth onClick={finish}>
					Complete
				</Button>
			</Grid>
		</Grid>
	);
};
export default MemberSignUps;
